import {
  REPORT_PLANT_FILTER,
  REPORT_LOCATIONTYPE_FILTER,
  REPORT_PRODUCT_FILTER,
  REPORT_STARTDATE_FILTER,
  REPORT_ENDDATE_FILTER,
  REPORT_TYPE_FILTER,
  REPORT_BILLING_TYPE_FILTER,
  REPORT_MOVEMENT_TYPE_FILTER,
  REPORT_FROM_PLANT_FILTER,
  REPORT_TO_PLANT_FILTER,
  REPORT_UNIT_FILTER,
  REPORT_COPY_ORIGINAL_SELECTED,
  REPORT_SEARCH_TRIGGER,
  ORDER_TRANSACTION_DOC_NUMBER_FILTER,
  ORDER_TRANSACTION_DOC_NUMBER_INV_FILTER,
  ORDER_TRANSACTION_DOC_NUMBER_REF_FILTER,
  ORDER_TRANSACTION_SHOW_ONLY_LAST_REF,
  ORDER_TRANSACTION_SHIP_START_DATE_FILTER,
  ORDER_TRANSACTION_SHIP_TO_DATE_FILTER,
  QUOTATION_TRANSACTION_SHOW_ONLY_MAX_REVISION,
  SUPPLIER_PO_TRANSACTION_DOC_NUMBER_FILTER,
  SUPPLIER_PO_TRANSACTION_DOC_NUMBER_INV_FILTER,
  SUPPLIER_PO_TRANSACTION_DOC_NUMBER_REF_FILTER,
  SUPPLIER_RETURN_DOC_NUMBER_FILTER,
  SUPPLIER_RETURN_DOC_NUMBER_INV_FILTER,
  SUPPLIER_RETURN_DOC_NUMBER_REF_FILTER,
  RETURN_TRANSACTION_DOC_NUMBER_FILTER,
  RETURN_TRANSACTION_DOC_REF_NUMBER_FILTER,
  RETURN_TRANSACTION_BILL_REF_NO_FILTER,
  INVOICE_TRANSACTION_DOC_NUMBER_FILTER,
  RECEIPT_TRANSACTION_DOC_NUMBER_FILTER,
  AR_REPORT_DOC_NUMBER_FILTER,
  AR_REPORT_DOC_STATUS_FILTER,
  EXPENSE_REPORT_DOC_NUMBER_FILTER,
  EXPENSE_DOC_NUMBER_FILTER,
  STOCK_TRANSACTION_DOC_NUMBER_FILTER,
  QUOTATION_TRANSACTION_DOC_NUMBER_FILTER,    
  QUOTATION_TRANSACTION_DOC_NUMBER_ORDER_FILTER,
  QUOTATION_TRANSACTION_DOC_NUMBER_REF_FILTER,
  INVOICE_TRANSACTION_DOCUMENT_TYPE_FILTER

} from "../constants/ActionTypes";

export const reportSelectPlant = (payload) => {
  return {
    type: REPORT_PLANT_FILTER,
    payload,
  };
};

export const reportSelectLocationType = (payload) => {
  return {
    type: REPORT_LOCATIONTYPE_FILTER,
    payload,
  };
};

export const reportSelectProduct = (payload) => {
  return {
    type: REPORT_PRODUCT_FILTER,
    payload,
  };
};

export const reportSelectStartDate = (payload) => {
  return {
    type: REPORT_STARTDATE_FILTER,
    payload,
  };
};

export const reportSelectEndDate = (payload) => {
  return {
    type: REPORT_ENDDATE_FILTER,
    payload,
  };
};

export const reportSelectType = (payload) => {
  return {
    type: REPORT_TYPE_FILTER,
    payload,
  };
};

export const reportBillingSelectType = (payload) => {
  return {
    type: REPORT_BILLING_TYPE_FILTER,
    payload,
  };
};

export const reportSelectMovementType = (payload) => {
  return {
    type: REPORT_MOVEMENT_TYPE_FILTER,
    payload,
  };
};

export const reportSelectFromPlant = (payload) => {
  return {
    type: REPORT_FROM_PLANT_FILTER,
    payload,
  };
};

export const reportSelectToPlant = (payload) => {
  return {
    type: REPORT_TO_PLANT_FILTER,
    payload,
  };
};

export const reportSelectUnit = (payload) => {
  return {
    type: REPORT_UNIT_FILTER,
    payload,
  };
};

export const reportSelectCopyOriginalType = (payload) => {
  return {
    type: REPORT_COPY_ORIGINAL_SELECTED,
    payload,
  };
};

export const reportSetSearchTrigger = (trigger) => {
  return {
    type: REPORT_SEARCH_TRIGGER,
    payload: trigger,
  };
};

//Order Transaction
export const orderTransactionDocNumberFilter = (payload) => {
  return {
    type: ORDER_TRANSACTION_DOC_NUMBER_FILTER,
    payload,
  };
};

export const orderTransactionDocNumberInvFilter = (payload) => {
  return {
    type: ORDER_TRANSACTION_DOC_NUMBER_INV_FILTER,
    payload,
  };
};

export const orderTransactionDocNumberRefFilter = (payload) => {
  return {
    type: ORDER_TRANSACTION_DOC_NUMBER_REF_FILTER,
    payload,
  };
};

export const setShowOnlyLastRef = (payload) => {
  return {
    type: ORDER_TRANSACTION_SHOW_ONLY_LAST_REF,
    payload,
  };
};

// ช่วง "วันที่จัดส่ง" ของหน้าใบสั่งขาย — payload เป็น 'YYYY-MM-DD' หรือ "" (= ไม่กรอง)
export const orderTransactionShipStartDateFilter = (payload) => {
  return {
    type: ORDER_TRANSACTION_SHIP_START_DATE_FILTER,
    payload,
  };
};

export const orderTransactionShipToDateFilter = (payload) => {
  return {
    type: ORDER_TRANSACTION_SHIP_TO_DATE_FILTER,
    payload,
  };
};

export const setShowOnlyMaxRevision = (payload) => {
  return {
    type: QUOTATION_TRANSACTION_SHOW_ONLY_MAX_REVISION,
    payload,
  };
};

//SupplierPO Transaction
export const supplierPOTransactionDocNumberFilter = (payload) => {
  return {
    type: SUPPLIER_PO_TRANSACTION_DOC_NUMBER_FILTER,
    payload,
  };
};

export const supplierPOTransactionDocNumberInvFilter = (payload) => {
  return {
    type: SUPPLIER_PO_TRANSACTION_DOC_NUMBER_INV_FILTER,
    payload,
  };
};

export const supplierPOTransactionDocNumberRefFilter = (payload) => {
  return {
    type: SUPPLIER_PO_TRANSACTION_DOC_NUMBER_REF_FILTER,
    payload,
  };
};


//Quotation Transaction
export const quotationTransactionDocNumberFilter = (payload) => {
  return {
    type: QUOTATION_TRANSACTION_DOC_NUMBER_FILTER,
    payload,
  };
};

export const quotationTransactionDocNumberOrderFilter = (payload) => {
  return {
    type: QUOTATION_TRANSACTION_DOC_NUMBER_ORDER_FILTER,
    payload,
  };
};

export const quotationTransactionDocNumberRefFilter = (payload) => {
  return {
    type: QUOTATION_TRANSACTION_DOC_NUMBER_REF_FILTER,
    payload,
  };
};

// Return Transaction
export const returnTransactionDocNumberFilter = (payload) => {
  return {
    type: RETURN_TRANSACTION_DOC_NUMBER_FILTER,
    payload,
  };
};

export const returnTransactionDocRefNumberFilter = (payload) => {
  return {
    type: RETURN_TRANSACTION_DOC_REF_NUMBER_FILTER,
    payload,
  };
};

export const returnTransactionBillRefNoFilter = (payload) => {
    return {
      type: RETURN_TRANSACTION_BILL_REF_NO_FILTER,
      payload,
    };
};

//Invoice Transaction
export const invoiceTransactionDocNumberFilter = (payload) => {
  return {
    type: INVOICE_TRANSACTION_DOC_NUMBER_FILTER,
    payload,
  };
};

export const setDocumentTypeFilter = (payload) => {
  return {
    type: INVOICE_TRANSACTION_DOCUMENT_TYPE_FILTER,
    payload,
  };
};

//Receipt Transaction
export const receiptTransactionDocNumberFilter = (payload) => {
  return {
    type: RECEIPT_TRANSACTION_DOC_NUMBER_FILTER,
    payload,
  };
};

//ARReport


export const arReportDocNumberFilter = (payload) => {
  return {
    type: AR_REPORT_DOC_NUMBER_FILTER,
    payload,
  };
};

export const arReportSelectDocStatus = (payload) => {
  return {
    type: AR_REPORT_DOC_STATUS_FILTER,
    payload,
  };
};

export const expenseReportDocNumberFilter = (payload) => {
  return {
    type: EXPENSE_REPORT_DOC_NUMBER_FILTER,
    payload,
  };
};


export const expenseDocNumberFilter = (payload) => {
  return {
    type: EXPENSE_DOC_NUMBER_FILTER,
    payload,
  };
};

export const stockTransactionDocNumberFilter = (payload) => {
  return {
    type: STOCK_TRANSACTION_DOC_NUMBER_FILTER,
    payload,
  };
};

//Supplier Return Transaction
export const supplierReturnDocNumberFilter = (payload) => {
  return {
    type: SUPPLIER_RETURN_DOC_NUMBER_FILTER,
    payload,
  };
};

export const supplierReturnDocNumberInvFilter = (payload) => {
  return {
    type: SUPPLIER_RETURN_DOC_NUMBER_INV_FILTER,
    payload,
  };
};

export const supplierReturnDocNumberRefFilter = (payload) => {
  return {
    type: SUPPLIER_RETURN_DOC_NUMBER_REF_FILTER,
    payload,
  };
};

